import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  tradeDataChanged: false,
  TeamDataChanged: false,
  reOrderAble: false,
  isResetDataLoading: false,
  searchCaseOperation: '',
  searchCaseOrder: '',
  searchCaseGantt: '',
  isOrderPlanSelected: false,
  isOpPlanSelected: false,
  planId: 0,
  event_id: 0,
  local_event_id: 0,
  timezone_offset: 0,
  page_range_from_settings: 300,
  isWorkOrderDataChange: false,
  isGlobalDialogClosed: false,
  largeMode: true,
  storeTeam: [],
  storeTrades: [],
  storeAssign: [],
  serverStatus: false,
  storeTradeAssignmentIds: [],
  filterConfirmation: false,
  backEndUrl: '',
  erpType: '',
  defaultTeams: [],
  defaultTrades: [],
  defaultPairTrades: [],
  defaultAssignments: [],
  refreshTeamComponent: false,
  refreshTradeComponent: false,
  refreshAssignmentComponent: false,
  isBackendWorking: false,
  isEventsUpdated: false,
  weekStartDay: 1,
  cloudSchedularGantDataChanged: false,
  isAppliedEventPlan: false,
  cloudSchedulerFilterTeamDropdownValueChanged: false,
  isDataPulled: false,
  server_gmt:11,
};
const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setServer_gmt: (state, action) => {
      state.server_gmt = action.payload;
    },
    setCloudSchedularGantDataChanged: (state, action) => {
      state.cloudSchedularGantDataChanged = action.payload;
    },
    setCloudSchedulerFilterTeamDropdownValueChanged: (state, action) => {
      state.cloudSchedulerFilterTeamDropdownValueChanged = action.payload;
    },
    setIsDataPulled: (state, action) => {
      state.isDataPulled = action.payload;
    },
    setIsBackendWorking: (state, action) => {
      state.isBackendWorking = action.payload;
    },
    setDefaultPairTrades: (state, action) => {
      state.defaultPairTrades = action.payload;
    },
    setRefreshTeamComponent: (state, action) => {
      state.refreshTeamComponent = action.payload;
    },
    setRefreshTradeComponent: (state, action) => {
      state.refreshTradeComponent = action.payload;
    },
    setRefreshAssignmentComponent: (state, action) => {
      state.refreshAssignmentComponent = action.payload;
    },
    setWeekStartDay: (state, action) => {
      state.weekStartDay = action.payload;
    },
    setTeamDataChanged: (state, action) => {
      state.TeamDataChanged = action.payload;
    },
    setTradeDataChanged: (state, action) => {
      state.tradeDataChanged = action.payload;
    },
    setAssignments: (state, action) => {
      state.defaultAssignments = action.payload;
    },
    setTrades: (state, action) => {
      state.defaultTrades = action.payload;
    },
    setDefaultTeams: (state, action) => {
      state.defaultTeams = action.payload;
    },
    setbackEndUrl: (state, action) => {
      state.backEndUrl = action.payload;
    },
    setErpType: (state, action) => {
      state.erpType = action.payload;
    },
    setfilterConfirmation: (state, action) => {
      state.filterConfirmation = action.payload;
    },
    setstoreTradeAssignmentIds: (state, action) => {
      state.storeTradeAssignmentIds = action.payload;
    },
    setStoreAssign: (state, action) => {
      state.storeAssign = action.payload;
    },
    setStoreTrades: (state, action) => {
      state.storeTrades = action.payload;
    },
    setStoreTeam: (state, action) => {
      state.storeTeam = action.payload;
    },
    changelargeMode: (state) => {
      state.largeMode = !state.largeMode;
    },
    changeReOrderAble: (state, action) => {
      state.reOrderAble = action.payload;
    },
    changeResetDataLoadingBoolenValue: (state) => {
      state.isResetDataLoading = !state.isResetDataLoading;
    },
    setSearchCaseOp: (state, action) => {
      state.searchCaseOperation = action.payload;
    },
    setSearchCaseOrder: (state, action) => {
      state.searchCaseOrder = action.payload;
    },
    setSearchCaseGantt: (state, action) => {
      state.searchCaseGantt = action.payload;
    },
    setIsPlanSelected: (state, action) => {
      state.isOrderPlanSelected = action.payload.isOrderPlanSelected;
      state.isOpPlanSelected = action.payload.isOpPlanSelected;
      state.planId = action.payload.planId;
    },
    setEventId: (state, action) => {
      state.event_id = action.payload;
    },
    setLocalEventId: (state, action) => {
      state.local_event_id = action.payload;
    },
    setTimezoneOffset: (state, action) => {
      state.timezone_offset = action.payload;
    },
    setFetchSize: (state, action) => {
      state.page_range_from_settings = action.payload;
    },
    setIsWorkOrderDataChange: (state, action) => {
      state.isWorkOrderDataChange = action.payload;
    },
    setIsGlobalDialogClosed: (state, action) => {
      state.isGlobalDialogClosed = action.payload;
    },
    setServerStatus: (state, action) => {
      state.serverStatus = action.payload;
    },
    setIsEventsUpdated: (state, action) => {
      state.isEventsUpdated = action.payload;
    },
    setIsAppliedEventPlan: (state, action) => {
      state.isAppliedEventPlan = action.payload;
    },
  },
});
export const setServer_gmt =
  searchSlice.actions.setServer_gmt;
export const changeResetDataLoadingBoolenValue =
  searchSlice.actions.changeResetDataLoadingBoolenValue;
export const setWeekStartDay = searchSlice.actions.setWeekStartDay;
export const setRefreshTeamComponent =
  searchSlice.actions.setRefreshTeamComponent;
export const setRefreshTradeComponent =
  searchSlice.actions.setRefreshTradeComponent;
export const setRefreshAssignmentComponent =
  searchSlice.actions.setRefreshAssignmentComponent;
export const setSearchCaseOp = searchSlice.actions.setSearchCaseOp;
export const setAssignments = searchSlice.actions.setAssignments;
export const setTeamDataChanged = searchSlice.actions.setTeamDataChanged;
export const setTradeDataChanged = searchSlice.actions.setTradeDataChanged;
export const setTrades = searchSlice.actions.setTrades;
export const setDefaultPairTrades = searchSlice.actions.setDefaultPairTrades;
export const setSearchCaseOrder = searchSlice.actions.setSearchCaseOrder;
export const setSearchCaseGantt = searchSlice.actions.setSearchCaseGantt;
export const setIsPlanSelected = searchSlice.actions.setIsPlanSelected;
export const setEventId = searchSlice.actions.setEventId;
export const setLocalEventId = searchSlice.actions.setLocalEventId;
export const setTimezoneOffset = searchSlice.actions.setTimezoneOffset;
export const setFetchSize = searchSlice.actions.setFetchSize;
export const changeReOrderFunc = searchSlice.actions.changeReOrderAble;
export const setStoreTeam = searchSlice.actions.setStoreTeam;
export const setStoreTrades = searchSlice.actions.setStoreTrades;
export const setStoreAssign = searchSlice.actions.setStoreAssign;
export const setfilterConfirmation = searchSlice.actions.setfilterConfirmation;
export const setDefaultTeams = searchSlice.actions.setDefaultTeams;
export const setbackEndUrl = searchSlice.actions.setbackEndUrl;
export const setErpType = searchSlice.actions.setErpType;
export const setIsEventsUpdated = searchSlice.actions.setIsEventsUpdated;
export const setCloudSchedularGantDataChanged =
  searchSlice.actions.setCloudSchedularGantDataChanged;
export const setCloudSchedulerFilterTeamDropdownValueChanged =
  searchSlice.actions.setCloudSchedulerFilterTeamDropdownValueChanged;
export const setstoreTradeAssignmentIds =
  searchSlice.actions.setstoreTradeAssignmentIds;
export const setIsWorkOrderDataChange =
  searchSlice.actions.setIsWorkOrderDataChange;
export const setIsGlobalDialogClosed =
  searchSlice.actions.setIsGlobalDialogClosed;
export const setServerStatus = searchSlice.actions.setServerStatus;
export default searchSlice.reducer;
export const { changelargeMode } = searchSlice.actions;
export const setIsBackendWorking = searchSlice.actions.setIsBackendWorking;
export const setIsAppliedEventPlan = searchSlice.actions.setIsAppliedEventPlan;
export const setIsDataPulled = searchSlice.actions.setIsDataPulled;
